<template>
    <v-card >
      <v-card-text class="px-4">
        <RichText
          v-if="editing"
          :data="note.body"
          :rules="[requiredRule]"
          v-on:update-item="updateBody">
        </RichText>
        <p v-else v-html="renderedBody"></p>
      </v-card-text>
      <v-card-actions v-if="editing" class="mt-0 pt-0 pb-0">
        <v-layout row class="pr-2" v-if="editable">
        <v-btn
          class="ml-2 mt-0 mr-2 mb-3"
          color="success"
          :disabled="!canSave"
          @click="saveNote()">
          Save
        </v-btn>
          <v-btn class="ml-0 mt-0 mb-3" color="secondary" @click="cancelSaveNote()" >Cancel</v-btn>
        </v-layout>
      </v-card-actions>
      <v-divider></v-divider>
    </v-card>
</template>

<script>
import RichText from "@/components/cases/case-elements/RichText"
import MarkdownIt from "markdown-it"

const markdownParser = new MarkdownIt({
  html: true,
  breaks: true,
})

export default {
  name: "case-note",
  components: { RichText },
  data: () => ({
    panel: [true],
    original: undefined,
    requiredRule: value => !!value || 'Subject required.'
  }),
  props: {
    note: {
      type: Object,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    },
    noteIndex: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.original = { subject: this.note.subject, body: this.note.body }
  },
  computed: {
    canSave() {
      return !!this.note.subject
    },
    renderedBody() {
      return markdownParser.render((this.note && this.note.body) || "")
    },
    editable() {
      return (
        (this.currentUser && this.currentUser.isAccountAdmin) ||
        this.currentUser.id === this.note.author.id
      )
    }
  },
  methods: {
    saveNote() {
      this.$store.dispatch("saveCaseNote", { noteIndex: this.noteIndex, note: this.note })
    },
    cancelSaveNote() {
      this.note.subject = this.original.subject
      this.note.body = this.original.body
      this.$store.dispatch("editCaseNote", { noteIndex: this.noteIndex, editing: false })
    },
    updateBody({ data }) {
      this.note.body = data
    }
  }
}
</script>
